<template>
  <div class="Exam-Prepare-Outer">
    <div class="Exam-Prepare-Inner">
      <div class="Prepare-message">
        <br/>
        <span>Hello <strong>{{ExDetails.UserFullName}}</strong>,</span><br/><br/>
        <span>Welcome to the ({{ExDetails.Examination.shortdescription}}) exam. Carefully read the below details before clicking on the <strong>Start</strong> button</span>
      </div>
      <div class="Prepare-Padding">
      </div>
      <div class="Prepare-Header">
        <span>Exam Description</span>
      </div>
      <div class="Prepare-message">
        <span>{{ExDetails.Examination.fulldescription}}</span>
      </div>
      <div class="Prepare-Padding">
      </div>
      <div class="Prepare-Header">
        <span>Instructions</span>
      </div>
      <div class="Prepare-message">
        <span>This examination has a duration of {{hourmsg}} {{minutesmsg}}. It is a total of {{String(totalquestions)}} questions. The pass mark is {{passscore}}% and requires candidate to get {{correctAns}} questions correctly to pass the Exam. To start the exam, Click the <strong>Start</strong> button below.</span><br/><br/>
        <span>Note that after clicking the <strong>Start</strong> button the status of the Exam changes to STARTED and time begins to tick, this cannot be reversed, and candidate will be expected to follow through with the exam to completion</span>
        <br/><br/>
        <span>Good Luck</span>
      </div>
      <div class="Prepare-Padding">
      </div>
      <div class="start-button-box">
        <button @click="handleStartClick">Start</button>
      </div>
    </div>
    <MessageDisplay v-if="isRespMsg" :MType="msgType" :mmsg="vLoginResponse" />
    <MessageDisplay v-if="isErrorMsg" :MType="msgType" :mmsg="vconnectError" />
  </div>
</template>

<script>
import MessageDisplay from '@/components/MessageDisplay.vue'
export default {
  name: 'prepareExam',
  props: ['server', 'ExDetails', 'instituteCode', 'userExamCode', 'hourmsg', 'minutesmsg', 'totalquestions', 'passscore', 'correctAns'],
  data () {
    return {
      isErrorMsg: false,
      isRespMsg: false,
      ExQuestions: {bookedExamSingle: [], bookedexams: '', response: '', timeRemain: ''},
      vLoginResponse: '',
      vconnectError: '',
      msgType: '',
      httpStatus: ''
    }
  },
  methods: {
    handleStartClick: function () {
      this.isRespMsg = false
      this.isErrorMsg = false
      this.ExQuestions = ''
      this.$store.commit('onSpinner')
      const url = this.server.htp + '://' + this.server.IP + ':' + this.server.Port + this.server.Webapp + 'Booking/' + this.userExamCode
      fetch(url, {
        mode: 'cors',
        method: 'GET', // or 'PUT' 'POST'
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.$store.state.auth.token
        }
      }).then(res => {
        this.httpStatus = res.status
        return res.json()
      }).then(response => {
        console.log('Start-Questions-Response:', response)
        this.ExQuestions = response
        this.$store.commit('offSpinner')
        if (this.httpStatus === 403) {
          this.vLoginResponse = 'Access to Resource is Denied'
          this.isRespMsg = true
          this.msgType = 'MSG'
        } else if ((this.ExQuestions.response !== undefined) && this.ExQuestions.response.includes('Success')) {
          this.SuccessFull()
        } else {
          if (this.ExQuestions.response === undefined) {
            this.vconnectError = 'Server Error!!!'
            this.isErrorMsg = true
            this.msgType = 'ERR'
          } else {
            this.vLoginResponse = this.ExQuestions.response
            this.isRespMsg = true
            this.msgType = 'MSG'
          }
        }
      })
        .catch(error => {
          this.$store.commit('offSpinner')
          console.log('Start-Questions-Error:', error)
          this.vconnectError = 'Connection Error!!!'
          this.isErrorMsg = true
          this.msgType = 'ERR'
        })
    },
    SuccessFull () {
      this.$emit('StartSuccess', this.ExQuestions)
    }
  },
  components: {MessageDisplay}
}

</script>
<style scoped>
.Exam-Prepare-Outer{
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: center;
}
.Exam-Prepare-Inner {
  width: 600px;
  height: 100%;
  border-style: solid;
  border-width: 5px;
  border-color: lightgrey;
  border-radius: 20px;
}
@media screen and (max-width:600px) {
  .Exam-Prepare-Inner {
    width: 100%;
  }
}
.Prepare-Padding {
  height: 10px;
}
.Prepare-Header {
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.Prepare-Header span{
  font-size: 20px;
  margin-top: 0;
  margin-bottom: 0;
}
.Prepare-message {
  padding-left: 10px;
}
.Prepare-message span{
  font-size: 12px;
  margin-bottom: 0;
}
.start-button-box{
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
   align-items: center;
   justify-content: center;
  height:60px;
}
button{
  background-color: #395693;
  border-radius: 20px;
  height:40px;
  width:100px;
  color: white;
  font-size:15px;
  outline-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/prepareExam.vue